import React, { useState, useEffect, useCallback } from 'react';
import { useSceneLoaded } from '../hooks/useSceneLoaded';
import dynamic from 'next/dynamic';

const StartModal = dynamic(
  () =>
    import('@ozoneuniverse/canvas-components/dist/src/components/start-modal'),
  {
    ssr: false,
  }
);

const slidesContent = [
  {
    title: 'Let’s get you moving!',
    image: 'slide-1.png',
  },
  {
    title: 'Control your camera',
    image: 'slide-3.png',
  },
  {
    title: 'Movement tools',
    image: 'studio-slide.png',
  },
];

declare global {
  interface Window {
    renderManager?: any;
  }
}

export default function InstructionModal() {
  const { sceneFirstFullyLoaded } = useSceneLoaded();
  const [openStartModal, setOpenStartModal] = useState<boolean>(false);
  const [questManager, setQuestManager] = useState<any>(null);

  useEffect(() => {
    if (sceneFirstFullyLoaded) {
      const isSkipped = window?.localStorage.getItem('isSkipped');
      if (isSkipped !== 'true') {
        setOpenStartModal(true);
      }
    }
  }, [sceneFirstFullyLoaded]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.renderManager) {
      setQuestManager(window.renderManager.questManager);
    }
  }, []);

  return (
    <>
      <StartModal
        open={openStartModal}
        setOpen={setOpenStartModal}
        slidesContent={slidesContent}
        callback={() => null}
        openModalAvatarSelector={null}
        questManager={questManager}
        isFromExternal={true}
        isOpenInStartSystemAM={false}
        urlStartModal={''}
      />
    </>
  );
}
